import axios from "axios";
export default axios.create({
    baseURL: 'https://pallot.wegosecure.com/api/',
    //http://rtls.wegosecure.com/api/rtls/list
    //http://pallot.wegosecure.com/api/rtls/list
    headers: {
      "Content-type": "application/json"
    }
});
